import React, { useEffect, Children, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, MessageCircleIcon, ClipboardListIcon, VideoIcon, UnlockIcon, HeartHandshakeIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.5
  }
};
const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
export function ThankYouPage() {
  const whatsappNumber = '+52 452 105 8527';
  useEffect(() => {
    // Initialize fbq function and queue
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
    // Queue the pixel initialization and events
    // These will be processed when the script loads
    window.fbq('init', '889082626778270');
    window.fbq('track', 'PageView');
    window.fbq('track', 'Purchase', {
      content_name: 'META ADS ACOMPANAMIENTO 1:1',
      value: 67,
      currency: 'USD'
    });
    // Load the pixel script (it will process the queued events)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=889082626778270&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <main className="min-h-screen w-full bg-gradient-to-b from-slate-50 to-white" data-id="element-2">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#0084FF] to-[#0066CC] text-white" data-id="element-3">
        <div className="absolute inset-0 opacity-50" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-4"></div>

        <motion.div className="relative max-w-4xl mx-auto px-4 py-16 md:py-24 text-center" initial="initial" animate="animate" variants={staggerContainer} data-id="element-5">
          <motion.div className="inline-flex items-center justify-center w-20 h-20 md:w-24 md:h-24 bg-green-500 rounded-full mb-6 shadow-lg shadow-green-500/30" variants={fadeInUp} data-id="element-6">
            <CheckCircleIcon className="w-12 h-12 md:w-14 md:h-14 text-white" strokeWidth={2.5} data-id="element-7" />
          </motion.div>

          <motion.h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight" variants={fadeInUp} data-id="element-8">
            ✅ ¡Listo! Ya formas parte de META ADS ACOMPANAMIENTO 1:1 🎉
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto mb-8" variants={fadeInUp} data-id="element-9">
            Tomaste una decisión clave: aprender a controlar tu propia máquina
            de clientes en vez de seguir tirando dinero a ciegas.
          </motion.p>

          <motion.div className="max-w-3xl mx-auto rounded-2xl overflow-hidden shadow-2xl shadow-black/20" variants={fadeInUp} data-id="element-10">
            <img src="https://cdn.magicpatterns.com/uploads/2MF4gNxYpNxtHzG4SNgdsE/ChatGPT_Image_4_dic_2025,_01_39_35_p.m..png" alt="Meta Ads 1:1 - Aprende Meta Ads con clases personalizadas para dominar la publicidad en Meta" className="w-full h-auto" data-id="element-11" />
          </motion.div>
        </motion.div>
      </section>

      {/* Steps Section */}
      <section className="max-w-4xl mx-auto px-4 py-12 md:py-16" data-id="element-12">
        <motion.h2 className="text-2xl md:text-3xl font-bold text-slate-800 text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-13">
          Sigue estos pasos para empezar:
        </motion.h2>

        <div className="space-y-6" data-id="element-14">
          {/* Step 1: WhatsApp */}
          <motion.div className="bg-white rounded-2xl border-2 border-[#25D366]/20 shadow-lg shadow-[#25D366]/5 overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-15">
            <div className="bg-gradient-to-r from-[#25D366] to-[#128C7E] px-6 py-4 flex items-center gap-3" data-id="element-16">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-17">
                <MessageCircleIcon className="w-5 h-5 text-white" data-id="element-18" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-19">
                1️⃣ Revisa tu WhatsApp 📲
              </h3>
            </div>

            <div className="p-6 space-y-4" data-id="element-20">
              <p className="text-slate-700 leading-relaxed" data-id="element-21">
                En las próximas horas vas a recibir una llamada o mensaje por
                WhatsApp para:
              </p>

              <ul className="space-y-2 text-slate-700" data-id="element-22">
                <li className="flex items-start gap-2" data-id="element-23">
                  <span className="text-[#25D366] font-bold" data-id="element-24">•</span>
                  <span data-id="element-25">Confirmar tu pago.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-26">
                  <span className="text-[#25D366] font-bold" data-id="element-27">•</span>
                  <span data-id="element-28">Hacerte 2–3 preguntas rápidas sobre tu negocio.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-29">
                  <span className="text-[#25D366] font-bold" data-id="element-30">•</span>
                  <span data-id="element-31">Coordinar tu primera sesión 1:1.</span>
                </li>
              </ul>

              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mt-4" data-id="element-32">
                <p className="text-slate-700" data-id="element-33">
                  Si en 24 horas hábiles no recibes nada, escríbeme tú con el
                  mensaje:
                </p>
                <p className="mt-2 text-slate-800 font-medium italic bg-white rounded-lg p-3 border border-amber-200" data-id="element-34">
                  &quot;Hola, ya pagué META ADS ACOMPANAMIENTO 1:1 y quiero
                  agendar mi primera sesión.&quot;
                </p>
                <div className="mt-4 pt-4 border-t border-amber-200" data-id="element-35">
                  <p className="text-slate-700 text-sm mb-2" data-id="element-36">Contáctame al:</p>
                  <a href={`https://wa.me/${whatsappNumber.replace(/\s+/g, '')}`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#25D366] text-white font-bold px-4 py-2 rounded-lg hover:bg-[#128C7E] transition-colors" data-id="element-37">
                    <MessageCircleIcon className="w-5 h-5" data-id="element-38" />
                    {whatsappNumber}
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Step 2: Form */}
          <motion.div className="bg-white rounded-2xl border-2 border-[#0084FF]/20 shadow-lg shadow-[#0084FF]/5 overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-39">
            <div className="bg-gradient-to-r from-[#0084FF] to-[#0066CC] px-6 py-4 flex items-center gap-3" data-id="element-40">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-41">
                <ClipboardListIcon className="w-5 h-5 text-white" data-id="element-42" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-43">
                2️⃣ Dame información sobre ti ✍️
              </h3>
            </div>

            <div className="p-6 space-y-4" data-id="element-44">
              <p className="text-slate-700 leading-relaxed" data-id="element-45">
                Solo te pediré lo esencial:
              </p>

              <ul className="space-y-2 text-slate-700" data-id="element-46">
                <li className="flex items-start gap-2" data-id="element-47">
                  <span className="text-[#0084FF] font-bold" data-id="element-48">•</span>
                  <span data-id="element-49">Qué vendes y desde qué país.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-50">
                  <span className="text-[#0084FF] font-bold" data-id="element-51">•</span>
                  <span data-id="element-52">Si ya corriste campañas o empiezas desde cero.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-53">
                  <span className="text-[#0084FF] font-bold" data-id="element-54">•</span>
                  <span data-id="element-55">
                    Tu objetivo principal (leads, ventas, agenda llena, etc.).
                  </span>
                </li>
              </ul>

              <p className="text-slate-600 italic mt-4 bg-slate-50 rounded-lg p-4" data-id="element-56">
                Así llegamos a la primera sesión listos para trabajar directo en
                tus campañas.
              </p>
            </div>
          </motion.div>

          {/* Step 3: First Session */}
          <motion.div className="bg-white rounded-2xl border-2 border-purple-200 shadow-lg shadow-purple-500/5 overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-57">
            <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-6 py-4 flex items-center gap-3" data-id="element-58">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-59">
                <VideoIcon className="w-5 h-5 text-white" data-id="element-60" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-61">
                3️⃣ Prepárate para tu primera sesión 1:1 🎯
              </h3>
            </div>

            <div className="p-6 space-y-4" data-id="element-62">
              <p className="text-slate-700 leading-relaxed" data-id="element-63">
                En esa llamada vamos a:
              </p>

              <ul className="space-y-2 text-slate-700" data-id="element-64">
                <li className="flex items-start gap-2" data-id="element-65">
                  <span className="text-purple-600 font-bold" data-id="element-66">•</span>
                  <span data-id="element-67">Revisar tu cuenta, negocio y oferta.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-68">
                  <span className="text-purple-600 font-bold" data-id="element-69">•</span>
                  <span data-id="element-70">Ver si tu Business Manager está bien configurado.</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-71">
                  <span className="text-purple-600 font-bold" data-id="element-72">•</span>
                  <span data-id="element-73">
                    Definir tu primer embudo de Meta Ads dentro del programa.
                  </span>
                </li>
              </ul>

              <div className="bg-purple-50 border border-purple-200 rounded-xl p-4 mt-4" data-id="element-74">
                <p className="text-slate-800 font-medium" data-id="element-75">
                  Tu tarea ahora es simple:{' '}
                  <span className="text-purple-700 font-bold" data-id="element-76">
                    revisar WhatsApp, completar el formulario y llegar con ganas
                    de ejecutar.
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* What You Unlocked Section */}
      <section className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-12 md:py-16" data-id="element-77">
        <motion.div className="max-w-4xl mx-auto px-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-78">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-79">
            <UnlockIcon className="w-8 h-8 text-yellow-400" data-id="element-80" />
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-81">
              Lo que acabas de desbloquear 🔓
            </h2>
          </div>

          <p className="text-slate-300 text-center mb-8 text-lg" data-id="element-82">
            A partir de hoy vamos a:
          </p>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-83">
            <motion.div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} data-id="element-84">
              <p className="text-white leading-relaxed" data-id="element-85">
                Trabajar 1:1 dentro de tu propia cuenta de anuncios.
              </p>
            </motion.div>

            <motion.div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-86">
              <p className="text-white leading-relaxed" data-id="element-87">
                Pasar de &quot;no sé qué tocar&quot; a saber:
              </p>
              <ul className="mt-2 space-y-1 text-slate-300" data-id="element-88">
                <li data-id="element-89">• qué campaña vende,</li>
                <li data-id="element-90">• cuál quema presupuesto,</li>
                <li data-id="element-91">• y qué ajustar cada día.</li>
              </ul>
            </motion.div>

            <motion.div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} data-id="element-92">
              <p className="text-white leading-relaxed" data-id="element-93">
                Construir estructuras de escalado y contingencia para que tu
                negocio no se apague por un bloqueo.
              </p>
            </motion.div>

            <motion.div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 border border-white/10" initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-94">
              <p className="text-white leading-relaxed" data-id="element-95">
                Usar IA para generar creativos y landings que convierten más
                rápido.
              </p>
            </motion.div>
          </div>

          <motion.div className="mt-8 text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-96">
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-97">
              En resumen: dejaste de depender de agencias y freelancers para
              siempre.
            </p>
          </motion.div>
        </motion.div>
      </section>

      {/* Commitment Section */}
      <section className="max-w-4xl mx-auto px-4 py-12 md:py-16" data-id="element-98">
        <motion.div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl border-2 border-orange-200 p-8 md:p-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-99">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-100">
            <HeartHandshakeIcon className="w-8 h-8 text-orange-600" data-id="element-101" />
            <h2 className="text-2xl md:text-3xl font-bold text-slate-800" data-id="element-102">
              Lo único que necesito de ti 💪
            </h2>
          </div>

          <ul className="space-y-4 max-w-xl mx-auto" data-id="element-103">
            <li className="flex items-start gap-3" data-id="element-104">
              <span className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold" data-id="element-105">
                ✓
              </span>
              <span className="text-slate-700 text-lg" data-id="element-106">
                Compromiso para asistir a las sesiones.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-107">
              <span className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold" data-id="element-108">
                ✓
              </span>
              <span className="text-slate-700 text-lg" data-id="element-109">
                Ejecución rápida entre sesión y sesión.
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-110">
              <span className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold" data-id="element-111">
                ✓
              </span>
              <span className="text-slate-700 text-lg" data-id="element-112">
                Transparencia con tus números y dudas.
              </span>
            </li>
          </ul>

          <div className="mt-8 text-center" data-id="element-113">
            <p className="text-xl md:text-2xl font-bold text-slate-800" data-id="element-114">
              Si tú haces tu parte, yo me encargo de que no vuelvas a caminar a
              ciegas en Meta Ads. 🚀
            </p>
          </div>
        </motion.div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-100 py-8 text-center" data-id="element-115">
        <p className="text-slate-500 text-sm" data-id="element-116">META ADS ACOMPANAMIENTO 1:1</p>
      </footer>
    </main>;
}